import { isFromMvpdConfirmation } from '../mvpd/signInHandoff';
import { getEnabledPartnerBindContext } from '../partner';

/**
 * Legacy SignIn.vue parity for the sign-in page's TV-provider block (the
 * OR divider + explainer + connect CTA). Hidden when:
 * - arriving from the MVPD confirmation screen, any region — legacy
 *   displayMVPDConnectCTA returns false on fromConfirmation (re-showing the
 *   CTA would loop the user back into /partner mid-bind), or
 * - a billing-partner flow is active where the region hides it — legacy
 *   showMVPDCtaIntl requires !isPartner, so INTL blueprints set
 *   options.partnerFlowHidesMvpdCta; US legacy keeps the CTA in CSP partner
 *   flows and so does TN.
 * The rendezvous sign-in-only handoff becomes a third term here when it
 * lands.
 */
export const shouldHideMvpdCta = (getConfigByKey: (key: string) => unknown): boolean =>
    isFromMvpdConfirmation() ||
    (!!getConfigByKey('options.partnerFlowHidesMvpdCta') &&
        getEnabledPartnerBindContext(getConfigByKey) !== null);

/**
 * Reads the flag the dtc machine detected on signIn entry (detectHideMvpdCta
 * action) out of a flow snapshot. Components stay dumb: they consume machine
 * state through this selector instead of touching query/storage/config
 * themselves.
 */
export const selectHideMvpdCta = (
    flowState: { context?: { hideMvpdCta?: boolean } } | null,
): boolean => flowState?.context?.hideMvpdCta ?? false;
